import { createReducer } from 'deox';
import { OrganisationMembership, UserMembership, Paging } from '@/types';
import { fetchMembersActions, getUserInfoActions } from '../actions/membership';

export interface CustomersState {
  data?: { organisation: OrganisationMembership; user: UserMembership }[];
  paging: Paging;
  userInfo: {
    email: string;
    memberships: {
      membershipId: string;
      organisationId: string;
      roleName: string;
      token: string;
      organisationName: string;
    }[];
    userId: string;
    firstName?: string;
    lastName?: string;
  };
}

const initialState: CustomersState = {
  data: undefined,
  paging: {
    pageNumber: 0,
    pageSize: 0,
    totalRecords: 0,
  },
  userInfo: {
    email: '',
    memberships: [],
    userId: '',
  },
};

const customersMembership = createReducer(initialState, (handleAction) => [
  handleAction(fetchMembersActions.success, (state, { payload }) => ({
    ...state,
    data: payload.data,
    paging: payload.paging,
  })),
  handleAction(getUserInfoActions.success, (state, { payload }) => ({
    ...state,
    userInfo: payload,
  })),
]);

export default customersMembership;
